import { render, staticRenderFns } from "./LabelDialog.vue?vue&type=template&id=58cfbc37&"
import script from "./LabelDialog.vue?vue&type=script&lang=js&"
export * from "./LabelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports